import { createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import { auth, firestore as db } from "../config/Config";

const  initialState={
    kitchenDetergentHolderBasicData:[],
    kitchenDetergentHolderBasicLoader:true,
    kitchenDetergentHolderBasicError:"",
}

export const fetchKitchenDetergentHolderBasicList = createAsyncThunk('fetchDetergentHolderBasic',
async()=>{
    const projectList = await db
    .collectionGroup("detergent_holder_basic")
    // .where("status", "==", "Ongoing")
    // .where("ID", "==", auth.currentUser.uid)
    .get();
  const projectListArray = [];
  for (var snap of projectList.docs) {
    var data = snap.data();
    data.ID = snap.id;
    projectListArray.push({
      ...data,
    });
    if (projectListArray.length === projectList.docs.length) {
      return projectListArray
    }
  }
});

const kitchenDetergentHolderBasicReducer = createSlice({
    name:'kitchenDetergentHolderBasic',
    initialState,
    reducers:{},
    extraReducers:{
        [fetchKitchenDetergentHolderBasicList.fulfilled]:(state,action)=>{
            state.kitchenDetergentHolderBasicData = action.payload
            state.kitchenDetergentHolderBasicLoader = false
        },
        [fetchKitchenDetergentHolderBasicList.pending]:(state,action)=>{
            state.kitchenDetergentHolderBasicLoader = true
        },
        [fetchKitchenDetergentHolderBasicList.rejected]:(state,action)=>{
            state.kitchenDetergentHolderBasicError = "refresh the page"
        },
    }
});

export default kitchenDetergentHolderBasicReducer.reducer